module.exports = __webpack_public_path__ + "static/media/06(5).7f487ec2.jpg";